import React, { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";

function formatDateDDMMYYYY(isoStr) {
  if (!isoStr) return "";
  const [y, m, d] = isoStr.split("-");
  return `${d}/${m}/${y}`;
}

function parseDDMMYYYY(str) {
  const match = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!match) return "";
  const [, d, m, y] = match;
  return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
}

export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function plusOneMonthISO(isoStr) {
  const d = new Date(isoStr + "T00:00:00");
  d.setMonth(d.getMonth() + 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export default function DateInputVN({ value, onChange, ...props }) {
  const [text, setText] = useState(formatDateDDMMYYYY(value));
  useEffect(() => { setText(formatDateDDMMYYYY(value)); }, [value]);

  const handleChange = (e) => {
    let v = e.target.value.replace(/[^\d/]/g, "");
    const digits = v.replace(/\//g, "");
    if (digits.length <= 2) v = digits;
    else if (digits.length <= 4) v = digits.slice(0, 2) + "/" + digits.slice(2);
    else v = digits.slice(0, 2) + "/" + digits.slice(2, 4) + "/" + digits.slice(4, 8);
    setText(v);
    const iso = parseDDMMYYYY(v);
    if (iso) onChange(iso);
  };

  return <Input {...props} type="text" inputMode="numeric" value={text} onChange={handleChange} placeholder="dd/mm/yyyy" maxLength={10} />;
}
